import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _NewQuizAndItemAnalysisPresenter;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import { Heading } from '@instructure/ui-heading';
import NewItemAnalysis from './NewItemAnalysis';
import NewQuizAnalysis from './NewQuizAnalysis';
import t from '@instructure/quiz-i18n/format-message';
import { AnalysisUpdateDate } from '../common/AnalysisUpdateDate';
import { itemAnalysisPropType, quizAnalysisPropType } from '../common/propTypes';
import PropTypes from 'prop-types';
import { QuizzesSpinner } from '../../../../common/components/shared/spinner/Spinner';
import { Spinner } from '@instructure/ui-spinner';
import { Button } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { getFailedToFetchReports } from '../common/errorMessages';
import { Img } from '@instructure/ui-img';
import errorImage from './downForRepair.svg';
import { PresentationContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import { csvFormat } from './exportFormats';
import { ExportButton } from './ExportButton';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
export var NewQuizAndItemAnalysisPresenter = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_NewQuizAndItemAnalysisPresenter = /*#__PURE__*/function (_Component) {
  function NewQuizAndItemAnalysisPresenter() {
    var _this2;
    _classCallCheck(this, NewQuizAndItemAnalysisPresenter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, NewQuizAndItemAnalysisPresenter, [].concat(args));
    _defineProperty(_this2, "renderItemAnalyses", function () {
      var itemAnalyses = _this2.props.itemAnalyses || [];
      return jsx(React.Fragment, null, jsx(Heading, {
        level: "h2",
        themeOverride: {
          h2FontWeight: 700
        },
        color: "primary"
      }, t('Item Analysis')), jsx("div", null, itemAnalyses.map(function (itemAnalysis) {
        return jsx(NewItemAnalysis, {
          key: itemAnalysis.metadata.item_id,
          itemAnalysis: itemAnalysis
        });
      })));
    });
    _defineProperty(_this2, "renderSpinner", function () {
      return jsx(Flex, {
        padding: "medium",
        justifyItems: "center",
        alignItems: "center"
      }, jsx(Spinner, {
        renderTitle: t('Loading item analyses data')
      }));
    });
    _defineProperty(_this2, "renderBodyOnFailedFetch", function () {
      return jsx(Flex, {
        alignItems: "end",
        width: "82.5rem",
        margin: "auto",
        direction: "column"
      }, jsx(Flex.Item, {
        align: "center"
      }, jsx(PresentationContent, null, jsx(Img, {
        src: errorImage,
        alt: ""
      }))), jsx(Flex.Item, {
        align: "center"
      }, jsx(Text, {
        size: "x-large",
        color: "primary"
      }, t('Error'))), jsx(Flex.Item, {
        align: "center"
      }, jsx(ScreenReaderContent, null, getFailedToFetchReports()), jsx(Text, {
        size: "x-small",
        color: "primary"
      }, getFailedToFetchReports())));
    });
    _defineProperty(_this2, "renderHeader", function () {
      var _quizAnalysis$metadat;
      var quizAnalysis = _this2.props.quizAnalysis;
      return jsx(Flex, {
        alignItems: "center",
        width: "auto",
        margin: "small auto",
        direction: "column"
      }, jsx(Flex.Item, {
        overflowY: "hidden"
      }, jsx(Heading, {
        level: "h2",
        themeOverride: {
          h2FontWeight: 700
        },
        margin: "0 x-large 0 0",
        color: "primary"
      }, quizAnalysis === null || quizAnalysis === void 0 || (_quizAnalysis$metadat = quizAnalysis.metadata) === null || _quizAnalysis$metadat === void 0 ? void 0 : _quizAnalysis$metadat.quiz_title)));
    });
    _defineProperty(_this2, "renderUpdateDateWithError", function () {
      var _this2$props = _this2.props,
        analysisError = _this2$props.analysisError,
        generationInProgress = _this2$props.generationInProgress,
        quizAnalysis = _this2$props.quizAnalysis;
      var shouldShowError = analysisError && !generationInProgress;
      var timeStamp = quizAnalysis === null || quizAnalysis === void 0 ? void 0 : quizAnalysis.created_timestamp;
      return jsx(Flex, {
        alignItems: "end",
        width: "auto",
        margin: "small auto",
        direction: "column"
      }, jsx(Flex.Item, null, timeStamp && jsx(AnalysisUpdateDate, {
        date: timeStamp
      })), jsx(Flex.Item, null, shouldShowError && jsx(Text, {
        size: "x-small",
        weight: "medium",
        color: "danger"
      }, analysisError)));
    });
    _defineProperty(_this2, "renderRightSide", function () {
      var exportEnabled = _this2.props.exportEnabled;
      return jsx(Flex, {
        alignItems: "center",
        justifyItems: "end",
        width: "auto",
        direction: "row",
        wrap: "wrap-reverse"
      }, jsx(Flex.Item, {
        padding: "0 small 0 0",
        margin: "0 0 0 auto"
      }, _this2.renderUpdateDateWithError()), jsx(Flex.Item, null, jsx("div", {
        css: _this2.props.styles.headerButtonsContainer
      }, exportEnabled && jsx(Flex.Item, {
        margin: "0 0 0 auto"
      }, _this2.renderExport()), jsx(Flex.Item, {
        margin: "0 0 0 auto"
      }, _this2.renderGenerationButton()))));
    });
    _defineProperty(_this2, "renderExport", function () {
      var _this2$props2 = _this2.props,
        quizAnalysis = _this2$props2.quizAnalysis,
        generationInProgress = _this2$props2.generationInProgress;
      return jsx(ExportButton, {
        quizAnalysis: quizAnalysis,
        generationInProgress: generationInProgress,
        handleExport: _this2.handleExport
      });
    });
    _defineProperty(_this2, "isEmptyReport", function () {
      var _this2$props3 = _this2.props,
        fetchInProgress = _this2$props3.fetchInProgress,
        quizAnalysis = _this2$props3.quizAnalysis,
        itemAnalyses = _this2$props3.itemAnalyses,
        analysisError = _this2$props3.analysisError;
      return !fetchInProgress && !quizAnalysis && !itemAnalyses && !analysisError;
    });
    _defineProperty(_this2, "renderTop", function () {
      return jsx(Flex, {
        justifyItems: "space-between",
        alignItems: "center",
        wrap: "wrap",
        width: "auto",
        margin: "0 auto small 0",
        direction: "row"
      }, jsx(Flex.Item, null, _this2.renderHeader()), jsx(Flex.Item, {
        margin: "0 0 0 auto"
      }, _this2.renderRightSide()));
    });
    _defineProperty(_this2, "renderTopOnSuccessfulFetch", function () {
      return _this2.isEmptyReport() ? _this2.renderGenerationButton() : _this2.renderTop();
    });
    _defineProperty(_this2, "renderTopOnFailedFetch", function () {
      var exportEnabled = _this2.props.exportEnabled;
      return jsx(Flex, {
        direction: "row",
        justifyItems: "end",
        wrap: "wrap",
        width: "auto",
        margin: "auto"
      }, exportEnabled && jsx(Flex.Item, {
        overflowY: "visible"
      }, _this2.renderExport()), jsx(Flex.Item, {
        overflowY: "visible"
      }, _this2.renderGenerationButton()));
    });
    _defineProperty(_this2, "renderOngoingGenerationButton", function () {
      return jsx(Button, {
        color: "primary-inverse",
        interaction: "disabled",
        margin: "auto"
      }, jsx(QuizzesSpinner, {
        size: "x-small",
        color: "brand",
        minHeight: "0",
        mainText: t('Generation In Progress'),
        fontSize: "medium"
      }));
    });
    _defineProperty(_this2, "renderStartGenerationButton", function () {
      return jsx(Button, {
        color: "secondary",
        margin: "auto",
        onClick: _this2.handleGeneration,
        themeOverride: {
          lineHeight: '24px'
        }
      }, jsx(Text, {
        size: "medium"
      }, t('Generate Report')));
    });
    _defineProperty(_this2, "renderGenerationButton", function () {
      var generationInProgress = _this2.props.generationInProgress;
      var buttonVariant = generationInProgress ? _this2.renderOngoingGenerationButton() : _this2.renderStartGenerationButton();
      return jsx(React.Fragment, null, buttonVariant);
    });
    _defineProperty(_this2, "renderBody", function () {
      var _this2$props4 = _this2.props,
        fetchInProgress = _this2$props4.fetchInProgress,
        quizAnalysis = _this2$props4.quizAnalysis;
      // TODO need to refactor the NewQuizAnalysis to move out spinner logic
      return jsx(React.Fragment, null, (fetchInProgress || quizAnalysis) && jsx(NewQuizAnalysis, {
        quizAnalysis: quizAnalysis,
        fetchInProgress: fetchInProgress
      }), fetchInProgress ? _this2.renderSpinner() : _this2.renderItemAnalyses());
    });
    _defineProperty(_this2, "renderBodyOnSuccessfulFetch", function () {
      return !_this2.isEmptyReport() && _this2.renderBody();
    });
    _defineProperty(_this2, "handleGeneration", function (_event) {
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'last_attempt';
      _this2.props.generateReports(filter);
    });
    _defineProperty(_this2, "handleExport", function (_event) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : csvFormat;
      var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'last_attempt';
      _this2.props.exportReports(format, filter);
    });
    return _this2;
  }
  _inherits(NewQuizAndItemAnalysisPresenter, _Component);
  return _createClass(NewQuizAndItemAnalysisPresenter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        analysisFetchError = _this$props.analysisFetchError,
        fetchInProgress = _this$props.fetchInProgress;
      return jsx("div", {
        className: "fs-mask"
      }, !fetchInProgress && (analysisFetchError ? this.renderTopOnFailedFetch() : this.renderTopOnSuccessfulFetch()), analysisFetchError ? this.renderBodyOnFailedFetch() : this.renderBodyOnSuccessfulFetch());
    }
  }]);
}(Component), _defineProperty(_NewQuizAndItemAnalysisPresenter, "displayName", 'NewQuizAndItemAnalysisPresenter'), _defineProperty(_NewQuizAndItemAnalysisPresenter, "componentId", "Quizzes".concat(_NewQuizAndItemAnalysisPresenter.displayName)), _defineProperty(_NewQuizAndItemAnalysisPresenter, "propTypes", {
  quizAnalysis: quizAnalysisPropType,
  itemAnalyses: PropTypes.arrayOf(itemAnalysisPropType),
  fetchInProgress: PropTypes.bool.isRequired,
  generationInProgress: PropTypes.bool.isRequired,
  analysisFetchError: PropTypes.bool.isRequired,
  analysisError: PropTypes.string,
  generateReports: PropTypes.func.isRequired,
  exportReports: PropTypes.func.isRequired,
  exportEnabled: PropTypes.bool.isRequired,
  styles: PropTypes.object
}), _defineProperty(_NewQuizAndItemAnalysisPresenter, "defaultProps", {
  analysisError: void 0,
  quizAnalysis: void 0,
  itemAnalyses: void 0
}), _NewQuizAndItemAnalysisPresenter)) || _class);
export default NewQuizAndItemAnalysisPresenter;